import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";

interface ActionItemStepsResourcesProps {
  steps: string[] | null;
  resources: string[] | null;
}

export function ActionItemStepsResources({ steps, resources }: ActionItemStepsResourcesProps) {
  // Ensure we have arrays to work with
  const stepsArray = Array.isArray(steps) ? steps : [];
  const resourcesArray = Array.isArray(resources) ? resources : [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="bg-background">
        <CardHeader>
          <CardTitle className="text-foreground">Steps</CardTitle>
        </CardHeader>
        <CardContent>
          {stepsArray.length > 0 ? (
            <ul className="list-disc pl-4 space-y-2">
              {stepsArray.map((step, index) => (
                <li key={index} className="text-muted-foreground">{step}</li>
              ))}
            </ul>
          ) : (
            <p className="text-muted-foreground">No steps defined</p>
          )}
        </CardContent>
      </Card>

      <Card className="bg-background">
        <CardHeader>
          <CardTitle className="text-foreground">Resources Needed</CardTitle>
        </CardHeader>
        <CardContent>
          {resourcesArray.length > 0 ? (
            <ul className="list-disc pl-4 space-y-2">
              {resourcesArray.map((resource, index) => (
                <li key={index} className="text-muted-foreground">{resource}</li>
              ))}
            </ul>
          ) : (
            <p className="text-muted-foreground">No resources needed</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}